/* global modForm */
/**
 * This function tracks mouse movements for accessibility purposes
 */
export function trackMouseMovement() {
	modForm.opts.form.addEventListener('mousemove', function() {
		if (!modForm.opts.form.classList.contains('form--disable-step-focus')) {
			modForm.opts.form.classList.add('form--disable-step-focus');
		}
	});

	modForm.opts.form.querySelectorAll('fieldset label, input[type="radio"]').forEach(function(element) {
		element.addEventListener('mouseup', function() {
			modForm.radioButtonClickedByMouse = true;
		});
	});
}
